export default {
  data() {
    return {
      relatedDocError: null,
    };
  },

  methods: {
    blockInvalidKeys(event) {
      const key = event.key;
      const value = event.target.value;

      //allow special keys
      if (
        key === 'Backspace' ||
        key === 'Delete' ||
        key === 'ArrowLeft' ||
        key === 'ArrowRight' ||
        key === 'Tab'
      ) {
        return;
      }

      // Just Numbers
      if (!/^[0-9]$/.test(key)) {
        event.preventDefault();
        return;
      }

      // max 10 characters
      if (value.length >= 10) {
        event.preventDefault();
        return;
      }

      // Just if is empty
      if (value.length === 0 && !/[96]/.test(key)) {
        event.preventDefault();
        this.relatedDocError = ['Debe iniciar con 9 o 6'];
        return;
      }
    },

    validateRelatedDoc(value) {
      if (!value.length) {
        this.relatedDocError = null;
        return;
      }

      if (!/^[96]/.test(value)) {
        this.relatedDocError = ['Debe iniciar con 9 o 6'];
        return;
      }

      if (value.length < 10) {
        this.relatedDocError = ['Debe tener 10 dígitos'];
        return;
      }

      this.relatedDocError = null;
    },
  },
};
